// THIS FILE IS AUTO GENERATED
// ANY CHANGES WILL BE LOST DURING BUILD
// MODIFY THE .SCSS FILE INSTEAD
import { css } from 'lit';
/**
 * exports lit-element css
 * @export styles
 */
export const styles = [
    css `
:host([hidden]){display:none}:host{display:block;--default-font-family:"Segoe UI","Segoe UI Web (West European)","Segoe UI",-apple-system,BlinkMacSystemFont,Roboto,"Helvetica Neue",sans-serif;--default-font-size:14px;--theme-primary-color:#0078d7;--theme-dark-color:#005a9e}.ms-Icon{display:inline-block;font-family:FabricMDL2Icons;font-style:normal;font-weight:400;font-size:16px;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;margin:4px 0}.ms-Icon--ChevronDown::before{content:"\\\e70d"}.ms-Icon--ChevronUp::before{content:"\\\e70e"}.ms-Icon--Contact::before{content:"\\\e77b"}.ms-Icon--AddFriend::before{content:"\\\e8fa"}.ms-Icon--OutlookLogoInverse::before{content:"\\\eb6d"}
`
];
